import { CheckIcon } from "@chakra-ui/icons";
import { Box, Circle, Flex, Text } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { FiArrowLeft } from "react-icons/fi";
import { useNavigate } from "react-router-dom";

const steps = [
  { label: "Basic Info" },
  { label: "Work Experience" },
  { label: "Education & Projects" },
  { label: "Summary & Skills" },
];

export default function ConsumerStepper({
  currentStep,
  onBack,
  showBackButton = true,
}) {
  const navigate = useNavigate();
  const [scrolled, setScrolled] = useState(false);

  // Detect scroll to toggle shadow
  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const getBackRoute = (step) => {
    switch (step) {
      case 1:
        return "/me";
      case 2:
        return "/me/work-experience";
      case 3:
        return "/me/education-projects";
      case 4:
        return "/me/summary-skills";
      default:
        return "/me";
    }
  };

  const handleBack = onBack || (() => navigate(getBackRoute(currentStep)));
  const shouldShowBack = showBackButton && currentStep > 0;

  return (
    <Box
      w="100%"
      bg="transparent"
      pt={0}
      mt={0}
      pb={2}
      position="relative"
    >
      {/* Stepper Center Row */}
      <Flex justify="center" position="relative">
        {/* Back Button */}
        {shouldShowBack && (
          <Flex
            position="absolute"
            left="0"
            top="50%"
            transform="translateY(-50%)"
            cursor="pointer"
            align="center"
            gap={2}
            onClick={handleBack}
            color="gray.700"
            _hover={{ color: "brand.orange", transform: "translateY(-50%) translateX(-2px)" }}
            transition="all 0.2s ease"
            zIndex={10}
          >
            <FiArrowLeft size={20} />
          </Flex>
        )}

        <Flex
          align="center"
          gap={{ base: 6, md: 10 }}
          maxW="850px"
          w="100%"
          px={4}
        >
          {steps.map((step, index) => {
            const isCompleted = index < currentStep;
            const isActive = index === currentStep;

            return (
              <React.Fragment key={index}>
                {/* Step */}
                <Flex direction="column" align="center" minW="90px">
                  <Circle
                    size="34px"
                    bg={isActive || isCompleted ? "brand.orange" : "gray.200"}
                    color={isActive || isCompleted ? "white" : "gray.600"}
                    border="3px solid"
                    borderColor={
                      isActive || isCompleted ? "brand.orangeLight" : "gray.300"
                    }
                    boxShadow={
                      isActive ? "0 3px 10px rgba(255,102,0,0.3)" : "none"
                    }
                    transition="all 0.2s ease"
                  >
                    {isCompleted ? <CheckIcon boxSize={3.5} /> : index + 1}
                  </Circle>

                  <Text
                    fontSize="sm"
                    fontWeight={isActive ? "600" : "500"}
                    textAlign="center"
                    mt={2}
                    color={
                      isActive
                        ? "gray.900"
                        : isCompleted
                          ? "gray.700"
                          : "gray.500"
                    }
                  >
                    {step.label}
                  </Text>
                </Flex>

                {/* Connector */}
                {index < steps.length - 1 && (
                  <Box
                    flex="1"
                    h="2px"
                    bg={isCompleted ? "brand.orange" : "gray.300"}
                    borderRadius="full"
                    transition="all 0.2s ease"
                  />
                )}
              </React.Fragment>
            );
          })}
        </Flex>
      </Flex>

    </Box>
  );
}
